import { render, staticRenderFns } from "./ProjectLabels.vue?vue&type=template&id=d35929a6"
import script from "./ProjectLabels.vue?vue&type=script&lang=js"
export * from "./ProjectLabels.vue?vue&type=script&lang=js"
import style0 from "./ProjectLabels.vue?vue&type=style&index=0&id=d35929a6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports